<template>
  <div class="total_static">
    <img :src="src" alt class="total_img" v-if="$store.getters.tagsView" />
    <div class>{{str}}：{{total >=0 ? total:0}}{{unit}}</div>
  </div>
</template>

<script>
export default {
  name: "TotaListNum",
  props: {
    str: {
      type: String,
      default: "当前项目数"
    },
    total: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: "人"
    }
  },
  data() {
    return {
      src: require("./../../assets/total.png")
    };
  }
};
</script>

<style lang="scss" scoped>
.total_static {
  color: #111111;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  display: flex;
  align-items: center;
  float: right;
  line-height: 32px;
  .total_img {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
</style>